import React, { useState, useEffect } from "react";

const baseURL = process.env.PUBLIC_URL + '/assets';

const TopImage = ({ text }) => {
  const [imageUrl, setImageUrl] = useState("");

  useEffect(() => {
    const updateImage = () => {
      const isSmallScreen = window.innerWidth <= 768; // Adjust the threshold as needed
      const imageSrc = isSmallScreen ? "back_small.jpg" : "back.jpg";
      setImageUrl(`${baseURL}/${imageSrc}`);
    };

    updateImage(); // Call once to set initial image
    window.addEventListener("resize", updateImage); // Listen for window resize

    return () => {
      window.removeEventListener("resize", updateImage); // Clean up event listener
    };
  }, []);

  return (
    <div className="flex flex-col justify-center mt-24 text-2xl font-bold tracking-wide text-white capitalize whitespace-nowrap bg-white">
      <div className="flex overflow-hidden relative flex-col justify-center py-16 w-full min-h-[269px] max-md:max-w-full">
        <img
          loading="lazy"
          src={imageUrl} // Set the src dynamically
          className="object-cover absolute inset-0 size-full "
          alt="TopImage"
        />
        <div className="relative text-wrap justify-center items-start py-6 pr-16 pl-24 mt-20 w-full bg-zinc-900 bg-opacity-40 max-md:pr-5 max-md:pl-8 max-md:mt-10 max-md:max-w-full">
          {text}
        </div>
      </div>
    </div>
  );
};

export default TopImage;
